// extracted by mini-css-extract-plugin
export default {"container":"open-api_container__Ra0ir","flex":"open-api_flex__FoNtX"};